/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-rixml-modal[_ngcontent-%COMP%]   .ea-rixml-selectors[_ngcontent-%COMP%]{margin-bottom:70px}.ea-rixml-modal[_ngcontent-%COMP%]   .ea-rixml-footer[_ngcontent-%COMP%]{position:absolute;bottom:0;left:0;flex-direction:row-reverse;border-top:none;height:auto;padding:15px}"];
export { styles as styles };
